import { Component, Input, OnInit } from '@angular/core';
import { ControlService } from 'src/app/services/control.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { ScreenshotsComponent } from '../screenshots/screenshots.component';
import { ScreenrecordComponent } from '../screenrecord/screenrecord.component';

@Component({
    selector: 'app-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule, ScreenshotsComponent, ScreenrecordComponent]
})
export class MediaComponent implements OnInit {
  @Input() control:ControlService;
  @Input() device:any;
  ngOnInit(): void {
    window.onbeforeunload=null;
  }
}
